import { ContainerModule } from '@evertel/di'
import { AuthenticationController } from './controllers/AuthenticationController'
import { EmailVerificationController } from './controllers/EmailVerificationController'
import { RegistrationController } from './controllers/RegistrationController'

const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(AuthenticationController).to(AuthenticationController).inSingletonScope()
        m.bind(RegistrationController).to(RegistrationController)
        m.bind(EmailVerificationController).to(EmailVerificationController)
    })
]

export { DI_MODULES }
